<div *ngIf="error">
  {{ error }}
</div>
<form [formGroup]="form"
  (submit)="onSubmit()">
  <div class="input-group">
    <mat-form-field>
      <input matInput
        type="text"
        class="input-wide"
        placeholder="Organisation Name"
        formControlName="name">
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-form-field>
      <input matInput
        type="tel"
        class="input-wide"
        placeholder="Contact Phone Number"
        formControlName="contactNumber">
    </mat-form-field>
  </div>
  <div formGroupName="address">
    <div class="input-group">
      <mat-form-field>
        <input matInput
          type="text"
          class="input-wide"
          placeholder="Address Line 1"
          formControlName="address1">
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input matInput
          type="text"
          class="input-wide"
          placeholder="Address Line 2"
          formControlName="address2">
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input matInput
          type="text"
          placeholder="Town / Suburb"
          formControlName="town">
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input matInput
          type="text"
          placeholder="State"
          formControlName="state">
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input matInput
          type="text"
          class="input-narrow"
          placeholder="Postcode"
          formControlName="postcode">
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input matInput
          type="text"
          class="input-wide"
          placeholder="Country"
          formControlName="country">
      </mat-form-field>
    </div>
  </div>
  <div class="input-group">
    <mat-slide-toggle formControlName="enabled">Enabled</mat-slide-toggle>
    <p *ngIf="form.get('enabled').value === false">This organisation is disabled. Users will not be able to perform any actions.</p>
  </div>
  <div class="button-group">
    <button [disabled]="loading"
      role="button"
      color="primary"
      (click)="onSubmit()"
      mat-flat-button>{{ mode == FormMode.CREATE ? 'Create Organisation' : 'Save' }}</button>
  </div>
</form>